import { Button, Divider } from "@shopify/polaris";
import styles from "./Standard.module.css";
import { useContext } from "react";

import { TargetingForm } from "../TargetingForm";
import { StandardBundleContext } from "./Standard";
import { BundleTypes } from "../constants";

const StandardTargetForm = () => {
    const context = useContext(StandardBundleContext);
    const { fields, handleNext, dispatchBundleConfig, submit, bundleConfig } = context;

    const { value: targeting, onChange } = fields.targeting;

    const dispatchBundleTargeting = (obj: object) => {
        dispatchBundleConfig({
            key: "targeting",
            payload: { ...targeting, ...obj },
        });
        onChange({ ...targeting, ...obj });
    };

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>
            <TargetingForm
                targeting={targeting}
                dispatchBundleTargeting={dispatchBundleTargeting}
                bundleType={BundleTypes.STANDARD}
                dispatchBundleConfig={dispatchBundleConfig}
                submit={submit}
                additional={fields}
                bundleConfig={bundleConfig}
            />
            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(1, "Design")}>Back</Button>

                {/* <Button onClick={() => handleNext(3, "Setting")}>Next</Button> */}
            </div>
        </div>
    );
};

export default StandardTargetForm;
